module.exports = __webpack_public_path__ + "static/media/3GP.9ab4ff7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/3GP.svg
// module id = 1697
// module chunks = 17